import React, { useEffect, useState } from "react";
import { Grid, Box, CircularProgress } from '@mui/material';
import { BasicCard } from "../../shared/basicCard";
import { useApi } from "../../hooks/useApi";
import { BasicErrorLabel } from "../../shared/basicErrorLabel";
import { UploadImageButton } from "../../shared/uploadImageButton";
import { updateOrgSeasonLogoApi, updateTeamLogoApi } from "../../api/orgSeasonApi";
import { useOrgSeasonContext } from "../../context/orgSeasonContext";
import { Team } from "../../api/models/team";
import { useApiCallWithAuth } from "../../hooks/useApiCallWithAuth";
import { TeamAdminPage } from "./teamAdminPage";

export interface ManageLogoPanelProps {
    team: Team; 
}


export function ManageLogoPanel(props: ManageLogoPanelProps) {

    const [logoImageUrl, setLogoImageUrl] = useState<string>(props.team.logoLink || '');

        const [errorMessage, setErrorMessage] = useState<string>('');
        const [isLoading, setIsLoading] = useState<boolean>(false);
        const updateTeamLogoApiRequest = useApiCallWithAuth(updateTeamLogoApi);

    const { orgSeason, refreshOrgSeason } = useOrgSeasonContext();

    async function uploadImage(selectedFile: string) {
        if (orgSeason) {

            setIsLoading(true);
            setErrorMessage('');

            try{
               const uploadFileData = { image: selectedFile };
               await updateTeamLogoApiRequest.request(orgSeason.id, props.team.id, uploadFileData);
               refreshOrgSeason();
            }
            catch (error) {
                console.error("Error uploading image:", error);
                setErrorMessage("Failed to upload image. Please try again.");
            }

            setIsLoading(false);
 
        }
    }

    return (<>
        <Grid container spacing={3} alignItems="center">
            <Grid item><h3>Update Logo</h3></Grid>
        </Grid>
        <BasicCard>
            {orgSeason &&
                <Box>
                    <Grid container spacing={1} direction='column' >
                        <Grid>
                            {!logoImageUrl && <img src="https://colbrensportsprod.blob.core.windows.net/web/general/images/SampleOrganization.png" height={100} alt='placeholder logo' style={{ border: '1px solid #909090' }} />}
                            {logoImageUrl && <img src={logoImageUrl} height={100} alt='logo' style={{ border: '1px solid #909090' }} />}
                            <br/>
                            <span style={{ fontSize: '12px' }}>ideal size is 250 X 250 pixels</span>
                        </Grid>

                        <Grid>
                            {!isLoading && <UploadImageButton id="uploadImage" onChange={uploadImage} />}
                            {isLoading && <CircularProgress />}
                        </Grid>


                    </Grid>
                    {errorMessage && <BasicErrorLabel errors={[errorMessage]} />}
                </Box>
            }
        </BasicCard>
    </>
    );
}